import { useEffect, useState } from 'react';
import BannerCarousel from '../home/BannerCarousel';
import BrandsSection from '../home/BrandsSection';
import ProductsSection from '../home/ProductsSection';
import CollectionsSection from '../home/CollectionsSection';
import ServicesSection from '../home/ServicesSection';
import { useLanguage } from '../../context/LanguageContext';
import { Api } from '../../services/api';

const getRedirectUrl = (banner) => {
  if (!banner) {
    return '';
  }
  return banner.redirectUrl ?? banner.redirect_url ?? banner.url ?? '';
};

const HomePage = () => {
  const { t } = useLanguage();
  const [middleBanner, setMiddleBanner] = useState(null);

  useEffect(() => {
    let mounted = true;

    const normalizeMiddleBanner = (payload) => {
      const source = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
        ? payload.data
        : [];

      return source.find((banner) => Boolean(banner?.image)) || null;
    };

    Api.fetchMiddleHomeBanner()
      .then((data) => {
        if (!mounted) return;
        setMiddleBanner(normalizeMiddleBanner(data));
      })
      .catch(() => {
        if (!mounted) return;
        setMiddleBanner(null);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const bannerImage = middleBanner?.image;
  const bannerAlt =
    middleBanner?.title ||
    middleBanner?.description ||
    'Bold, Fresh, Fearless';
  const bannerRedirectUrl = getRedirectUrl(middleBanner);

  const handleBannerClick = () => {
    if (!bannerRedirectUrl) return;
    if (typeof window !== 'undefined') {
      window.location.assign(bannerRedirectUrl);
    }
  };

  const handleBannerKeyPress = (event) => {
    if (!bannerRedirectUrl) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleBannerClick();
    }
  };

  return (
    <div className="home">
      <BannerCarousel />
      <BrandsSection />
      <ProductsSection
        title={t('home.top_products')}
        variant="compact"
        limit={4}
        seeAllHref="/products"
        source="featured"
        showVariantLowestPrice
      />
      {bannerImage ? (
        <div
          className="home__feature-banner"
          role={bannerRedirectUrl ? 'button' : undefined}
          tabIndex={bannerRedirectUrl ? 0 : undefined}
          onClick={bannerRedirectUrl ? handleBannerClick : undefined}
          onKeyPress={bannerRedirectUrl ? handleBannerKeyPress : undefined}
        >
          <img src={bannerImage} alt={bannerAlt} loading="lazy" />
        </div>
      ) : null}
      <CollectionsSection />
      <ServicesSection />
      <ProductsSection
        title={t('home.new_arrivals')}
        variant="compact"
        limit={4}
        seeAllHref="/products?collection=new-arrivals"
        source="new-arrivals"
        showVariantLowestPrice
      />
    </div>
  );
};

export default HomePage;
